<template v-cloak>
	<Loading
		v-if="$store.cID == null || ($apollo.loading && !products.length)"
		:activated="true"
	/>
	<div v-else class="wishlist">
		<div v-if="wishlist.items.length && products.length">
			<p class="subtitle">{{ $language.wishlist.subtitle }}</p>
			<transition-group
				class="wishlist-grid"
				tag="div"
				name="fade"
				mode="out-in">
				<WishlistItem
					v-for="product in products"
					:product="product"
					:key="product.id"
				/>
			</transition-group>
		</div>
		<div
			v-else
			class="columns">
			<div class="column-left rte">
				<p class="empty-wishlist">{{ $language.wishlist.subtitle_empty }}</p>
			</div><!-- column-left -->

			<div class="column-right rte">
				<a href="/" class="btn with-arrow btn-wide">{{ $language.wishlist.continue_shopping }}</a>
			</div><!-- column-right -->
		</div>
	</div>
</template>

<script>
import WishlistItem from '../Components/WishlistItem'
import Loading from '../Components/Loading'
import { FETCH_PRODUCTS } from '../../scripts/queries'

export default {
	name: 'Wishlist',

	components: {
		WishlistItem,
		Loading
	},

	data () {
		return {
			nodes: []
		}
	},

	computed: {
		wishlist () {
			if (this.$store.wishlist === null || this.$isEmpty(this.$store.wishlist.list)) {
				return {
					items: []
				}
			}
			let listKey = Object.keys(this.$store.wishlist.list)[0]
			return this.$store.wishlist.list[listKey]
		},
		productIDs () {
			return this.wishlist.items.map(i => `${btoa('gid://shopify/Product/' + i.pid)}`)
		},
		products () {
			return this.nodes.filter(node => node !== null)
		}
	},

	apollo: {
		nodes: {
			query: FETCH_PRODUCTS,
			variables () {
				return {
					ids: this.productIDs
				}
			},
			skip () {
				return !this.wishlist || !this.wishlist.items.length || !this.productIDs.length
			}
		}
	},

	watch: {
		wishlist () {
			this.$apollo.queries.nodes.refetch()
		}
	}
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease-out;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
